import { useEffect } from 'react';
import {
    usePortfolioSelectedPosition,
    useSelectPortfolioStreamedOrSelectedOrders,
} from 'portfolio/store/hooks';
import { useDispatchLoadCurrency } from 'app/currencies/store/dispatcher';
import { useSelectCurrency } from 'app/currencies/store/selectors';

export function useSelectedOrderCurrency() {
    const dispatchLoadCurrency = useDispatchLoadCurrency();

    const streamedOrSelectedOrders =
        useSelectPortfolioStreamedOrSelectedOrders();
    const selectedPosition = usePortfolioSelectedPosition();

    const currencyCode =
        selectedPosition &&
        streamedOrSelectedOrders &&
        streamedOrSelectedOrders[0].curcy;

    useEffect(() => {
        if (currencyCode) {
            dispatchLoadCurrency(currencyCode);
        }
    }, [currencyCode, dispatchLoadCurrency]);

    return useSelectCurrency(currencyCode ?? '');
}
